import React from "react";

import "./style.css";

function List(props) {
  function renderInput() {
    if (props.type === "text")
      return (
        <input
          className="form-control"
          onChange={props.onChange}
          value={props.value}
        />
      );

    return (
      <select
        value={props.value}
        onChange={props.onChange}
        className="form-control"
      >
        <option value="" disabled>
          Gender
        </option>
        {props.options.map(item => (
          <option
            key={Math.random().toString()}
            value={item[props.optionValue]}
          >
            {item[props.optionLabel]}
          </option>
        ))}
      </select>
    );
  }

  return (
    <li>
      <span>{props.label}</span>
      {props.editing ? renderInput() : <span>{props.value}</span>}
    </li>
  );
}

List.defaultProps = {
  type: "text",
  optionLabel: "label",
  optionValue: "value",
  options: [],
  value: ""
};

export default List;
